<template>
  <b-button-group>
    <b-button
      v-for="option in options"
      :key="option.value"
      :variant="getVariant(isActive(option))"
      @click="setOption(option)"
    >
      <span v-if="option.icon"><fa-icon :icon="option.icon"/></span>
      <span v-if="option.label">{{ option.label }}</span>
    </b-button>
  </b-button-group>
</template>

<script>
import Vue from 'vue';

export default Vue.extend({
  props: {
    name: {
      type: String,
      required: true,
    },
    value: {
      type: String,
      required: false,
    },
    options: {
      type: Array,
      required: true,
    },
  },
  computed: {
    selectedOption() {
      return this.findOption(this.value);
    },
  },
  mounted() {
    if (this.$route.query[this.name]) {
      this.$emit('input', this.$route.query[this.name]);
    }
  },
  methods: {
    async setOption(o) {
      if (o && o.value !== this.$route.query[this.name]) {
        await this.$router.push({
          query: Object.assign({}, this.$route.query, {
            [this.name]: o && o.value ? o.value : undefined,
          }),
        });
      }
      this.$emit('input', o && o.value ? o.value : null);
    },
    findOption(value) {
      if (!value) {
        return null;
      }
      return this.options.find(
        o => o.value.toLowerCase() === value.toLowerCase()
      );
    },
    isActive(option) {
      return (
        this.selectedOption &&
        option &&
        this.selectedOption.value === option.value
      );
    },
    getVariant(bool) {
      return bool ? 'primary' : 'outline-primary';
    },
  },
});
</script>

<style scoped>
button {
  font-size: 0.76562rem !important;
  padding: 4px 7px;
}
.btn-outline-primary {
  background-color: white;
}
.btn-outline-primary:hover {
  background-color: #4d92e3;
}
</style>
